// @flow
import React from 'react';
import type {Node} from 'react';
import {Navigate, useParams} from 'react-router-dom';
import {useFeatureFlag, LD_FLAGS} from 'modules/feature-flags';
import {DocumentationLoader} from './DocumentationLoader';
import {DocumentationContainer} from './DocumentationContainer';

export const DocumentationRoot = (): Node => {
  const params = useParams();
  const hasPeersDocumentation = useFeatureFlag(LD_FLAGS.PEERS_DOCUMENTATION);

  if (!hasPeersDocumentation) {
    return <Navigate to="/" />;
  }

  return (
    <DocumentationLoader documentId={params.id}>
      {/* $FlowFixMe */}
      <DocumentationContainer />
    </DocumentationLoader>
  );
};
